import React from 'react';

import './Nav.scss';

export default class Logo extends React.Component {
  render() {
    return (
      <div className="Nav">
         {
           this.props.close  
           ?
            <div className="close" onClick={this.props.onClose}>&#215;</div>
           :
            <div className="newsite">New Site Coming Soon</div>
         }

      </div>
    );
  }
}

